import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import "../scss/welfare-rank.scss";

import { round } from "lodash";
import Color from "@/tool/color";
import moWelfare from "../store/wealfare";
import moIndex from "../../store";

interface IProps {
  onChange: (val: string) => void;
}
interface IState {}

const KeyWelfareRank = (props: IProps, state: IState) => {
  const { onChange } = props;
  const { keyHolidayLeft } = moWelfare;
  const {isMock} = moIndex
  const [current, setCurrent] = useState<number>(0);

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section
      className="welfare-ranks-left"
      style={{
        width: "45%",
        height: "auto",
      }}
    >
      <section className="welfare-ranks-content">
        {keyHolidayLeft?.map((item: any, i: any) => {
          return (
            <section
              aria-hidden="true"
              className={`welfare-ranks-item ${
                current === i ? "welfare-ranks-left-current" : ""
              }`}
              key={`${i.toString()}`}
              onMouseEnter={() => {
                setCurrent(i);
                onChange(item.name);
              }}
            >
              <span className="welfare-ranks-name">{item.name}</span>
              <section
                style={{
                  width: "70%",
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                <p style={{ width: `${item.percent * 100}%` }} />
                <span
                  style={{
                    marginLeft: "5px",
                    color: Color.blackColor(0.85),
                    fontWeight: 600,
                    fontFamily: "Roboto",
                  }}
                >
                  {round(item.percent * 100, 1)}%
                </span>
              </section>
            </section>
          );
        })}
      </section>
      <b className="welfare-ranks-lines" style={{ height: "100%" }} />
    </section>
  );
};

export default observer(KeyWelfareRank);
